import './BikeRentGrid.css';
export default function BikeRentGrid() {
    return (
        <div>
            <section class="filters container">
                <h2>Search Your Ride</h2>
                <div class="filter-bar">
                    <select>
                        <option>All Locations</option>
                        <option>Mumbai</option>
                        <option>Pune</option>
                        <option>Delhi</option>
                    </select>
                    <select>
                        <option>All Brands</option>
                        <option>Yamaha</option>
                        <option>BMW</option>
                        <option>Harley Davidson</option>
                    </select>
                    <select>
                        <option>All Categories</option>
                        <option>Sports</option>
                        <option>Cruiser</option>
                        <option>Adventure</option>
                    </select>
                    <select>
                        <option>Select Model</option>
                        <option>R15</option>
                        <option>MT-15</option>
                        <option>Classic 350</option>
                    </select>
                    <button class="search-btn">Search</button>
                    <button class="reset-btn">Reset</button>
                </div>
            </section>
            <section class="inventory container">
                <div class="bike-card">
                    <img src="https://images.unsplash.com/photo-1502877338535-766e1452684a?auto=format&fit=crop&w=800&q=80" alt="Suzuki GSX-R1000" />
                    <div class="bike-info">
                        <h3>Suzuki GSX-R1000 (2024)</h3>
                        <p class="price">$8,699</p>
                        <p><strong>Color:</strong> Blue/White</p>
                        <p><strong>Stock:</strong> 3 available</p>
                        <button>View Details</button>
                    </div>
                </div>

                <div class="bike-card">
                    <img src="https://images.unsplash.com/photo-1502877338535-766e1452684a?auto=format&fit=crop&w=800&q=80" alt="Kawasaki Versys" />
                    <div class="bike-info">
                        <h3>Kawasaki Versys 650 (2020)</h3>
                        <p class="price">$8,299</p>
                        <p><strong>Color:</strong> White</p>
                        <p><strong>Stock:</strong> 2 available</p>
                        <button>View Details</button>
                    </div>
                </div>

                <div class="bike-card">
                    <img src="https://images.unsplash.com/photo-1502877338535-766e1452684a?auto=format&fit=crop&w=800&q=80" alt="Triumph Street Triple" />
                    <div class="bike-info">
                        <h3>Triumph Street Triple R (2020)</h3>
                        <p class="price">$12,499</p>
                        <p><strong>Color:</strong> Black</p>
                        <p><strong>Stock:</strong> 5 available</p>
                        <button>View Details</button>
                    </div>
                </div>

                <div class="bike-card">
                    <img src="https://images.unsplash.com/photo-1502877338535-766e1452684a?auto=format&fit=crop&w=800&q=80" alt="Ducati 1199" />
                    <div class="bike-info">
                        <h3>Ducati 1199 Panigale (2012)</h3>
                        <p class="price">$12,999</p>
                        <p><strong>Color:</strong> Red</p>
                        <p><strong>Stock:</strong> 1 available</p>
                        <button>View Details</button>
                    </div>
                </div>
                <div class="bike-card">
                    <img src="https://images.unsplash.com/photo-1502877338535-766e1452684a?auto=format&fit=crop&w=800&q=80" alt="Kawasaki Versys" />
                    <div class="bike-info">
                        <h3>Kawasaki Versys 650 (2020)</h3>
                        <p class="price">$8,299</p>
                        <p><strong>Color:</strong> White</p>
                        <p><strong>Stock:</strong> 2 available</p>
                        <button>View Details</button>
                    </div>
                </div>

                <div class="bike-card">
                    <img src="https://images.unsplash.com/photo-1502877338535-766e1452684a?auto=format&fit=crop&w=800&q=80" alt="Triumph Street Triple" />
                    <div class="bike-info">
                        <h3>Triumph Street Triple R (2020)</h3>
                        <p class="price">$12,499</p>
                        <p><strong>Color:</strong> Black</p>
                        <p><strong>Stock:</strong> 5 available</p>
                        <button>View Details</button>
                    </div>
                </div>

                <div class="bike-card">
                    <img src="https://images.unsplash.com/photo-1502877338535-766e1452684a?auto=format&fit=crop&w=800&q=80" alt="Ducati 1199" />
                    <div class="bike-info">
                        <h3>Ducati 1199 Panigale (2012)</h3>
                        <p class="price">$12,999</p>
                        <p><strong>Color:</strong> Red</p>
                        <p><strong>Stock:</strong> 1 available</p>
                        <button>View Details</button>
                    </div>
                </div>
            </section>
            <div class="pagination container">
                <a href="#" class="active">1</a>
                <a href="#">2</a>
                <a href="#">3</a>
                <a href="#">Next</a>
            </div>
        </div>
    )
}